import { forwardRef } from "react";
import { Box, Typography } from "@mui/material";
import { Verified as VerifiedIcon, Cancel as CancelIcon } from "@mui/icons-material";
import { colors } from "../../../ui/colors";

export const FlownectBadge = forwardRef(({ hasFlownectAccount = false, ...props }, ref) => {
  const activeBgLight = "#FFF4E5";
  const activeGradient = "linear-gradient(135deg, #FB8E00 0%, #FFAB40 100%)";
  const inactiveGradient = "linear-gradient(135deg, #e5e7eb 0%, #9ca3af 100%)";
  const shadowFold = hasFlownectAccount ? "#CC7400" : "#4b5563";

  return (
    <Box
      ref={ref}
      {...props}
      sx={{
        background: activeBgLight,
        height: 50,
        position: "relative",
        borderTopLeftRadius: 12,
        borderTopRightRadius: 12,
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: -6,
          right: 18,
          width: 42,
          height: 120,
          background: hasFlownectAccount ? activeGradient : inactiveGradient,
          boxShadow: hasFlownectAccount ? "0 4px 12px rgba(251, 142, 0, 0.3)" : "0 2px 6px rgba(0,0,0,0.1)",

          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "flex-start",
          paddingTop: "12px",
          transition: "all 0.3s ease-in-out",
          cursor: !hasFlownectAccount ? "pointer" : "default",
          zIndex: 10,
          clipPath: "polygon(0 0, 100% 0, 100% 100%, 50% calc(100% - 12px), 0 100%)",

          "&:hover": {
            transform: !hasFlownectAccount ? "translateY(2px)" : "none",
          },

          "&::after": {
            content: '""',
            position: "absolute",
            top: 0,
            right: -6,
            width: 6,
            height: 6,
            background: shadowFold,
            clipPath: "polygon(0 0, 0 100%, 100% 100%)",
            zIndex: -1,
          },
        }}
      >
        {hasFlownectAccount ? (
          <VerifiedIcon sx={{ fontSize: 18, mb: 0.5, color: "#FFFFFF" }} />
        ) : (
          <CancelIcon sx={{ fontSize: 18, mb: 0.5, color: colors.gray[600], opacity: 0.6 }} />
        )}

        <Typography
          sx={{
            writingMode: "vertical-rl",
            pb: 2.25,
            fontWeight: 800,
            letterSpacing: "1px",
            textAlign: "center",
            fontSize: "0.6rem",
            userSelect: "none",
            textTransform: "uppercase",
            color: hasFlownectAccount ? "#FFFFFF" : "var(--fx-surface-textsecondary, #64748B)",
            fontFamily: "'Roboto Condensed', sans-serif",
          }}
        >
          FLOWNECT USER
        </Typography>
      </Box>
    </Box>
  );
});
